// extracted by mini-css-extract-plugin
export default {"loaderBox":"loader_loaderBox__F4yc7","loader":"loader_loader__QPwCu","spin":"loader_spin__2vYHb"};